import api from './api';

export const getMe = async () => {
  try {
    const response = await api.get('/me');
    return response.data;
  } catch (error) {
    console.error('Error fetching user data:', error);
    throw error;
  }
};

// Cadastrar número de telefone
export const registerPhone = async (phoneNumber, storeId = null) => {
  try {
    const body = { phoneNumber };
    if (storeId) {
      body.storeId = storeId;
    }
    const response = await api.post('/me/phone', body);
    return response.data;
  } catch (error) {
    console.error('Error registering phone number:', error);
    throw error;
  }
};

// Associar o usuário atual como vendedor adicional de uma loja que já possui vendedor,
// usando o telefone da loja, sem passar por verificação de código.
export const joinStoreAsSeller = async (storeId) => {
  try {
    const response = await api.post('/me/store-association', { storeId });
    return response.data;
  } catch (error) {
    console.error('Error joining store as seller:', error);
    throw error;
  }
};

// Verificar código recebido por SMS
export const verifyPhone = async (verificationCode) => {
  try {
    const response = await api.post('/me/phone/verify', { verificationCode });
    return response.data;
  } catch (error) {
    console.error('Error verifying phone code:', error);
    throw error;
  }
};

// Atualizar dados do usuário
export const updateMe = async (data) => {
  try {
    const response = await api.patch('/me', data);
    return response.data;
  } catch (error) {
    console.error('Error updating user data:', error);
    throw error;
  }
};

// Confirmar a troca de telefone com o código enviado ao novo número
export const confirmPhoneChange = async (verificationCode) => {
  try {
    const response = await api.post('/me/phone/change/verify', { verificationCode });
    return response.data;
  } catch (error) {
    console.error('Error confirming phone change:', error);
    throw error;
  }
};

// Excluir a conta do usuário atual (dados anonimizados no backend + login removido do Cognito)
export const deleteMe = async () => {
  try {
    await api.delete('/me');
  } catch (error) {
    console.error('Error deleting account:', error);
    throw error;
  }
};
